//按钮权限控制
function getMenuListFromCache() {
    try {
        const cached = window.localStorage.getItem('vuex')
        if (!cached) return []
        const parsed = JSON.parse(cached)
        const list = parsed?.menuList || []
        return Array.isArray(list) ? list : []
    } catch (error) {
        return []
    }
}

function collectPermissionCodes(list, set) {
    if (!Array.isArray(list)) return
    for (const item of list) {
        const menuType = item?.meta?.menuType
        const code = item?.meta?.permissionCode
        if (menuType === 'F' && code) {
            set.add(code)
        }
        if (Array.isArray(item?.children)) {
            collectPermissionCodes(item.children, set)
        }
    }
}

export function hasPermission(menuList, value) {
    if (!value) return true
    const list = Array.isArray(menuList) && menuList.length ? menuList : getMenuListFromCache()
    const set = new Set()
    collectPermissionCodes(list, set)

    if (Array.isArray(value)) {
        return value.some((v) => set.has(v))
    }
    return set.has(value)
}
